import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-success-confirm",
  "use": "icon-success-confirm-usage",
  "viewBox": "0 0 88 88",
  "content": "<symbol viewBox=\"0 0 88 88\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-success-confirm\">\n<rect width=\"88\" height=\"88\" rx=\"44\" fill=\"#76DC9F\" />\n<path d=\"M40.16 45.3846L30.56 33.3846L20 43.5385L41.12 62L68 37.0769L58.4 26L40.16 45.3846Z\" fill=\"#254826\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol